import axios from "axios";
import { IRulesApiFilter } from "../types";

interface IGetRulesCountParams {
    filters: IRulesApiFilter
}

export const getRulesCount = async (params: IGetRulesCountParams): Promise<{
    counter: {
        total: number
    }
}> => {
    const response = await axios.post('/booking/rule/counter', params)
    return response.data;
};